<vw-header-padding-safe-area></vw-header-padding-safe-area>
<div class="px-4 relative w-full h-full">
  <div class="flex justify-between items-center">
    <h2 class="text-[#062825] text-[32px] font-semibold pb-3">{{ "garden.title" | translate}}</h2>
    <vw-plus-icon class="text-white p-2 rounded-full bg-primary cursor-pointer"
      (click)="showActionsToast = true"></vw-plus-icon>
  </div>

  <vw-tab [tabs]="tabData" (tabSelected)="onTabSelected($event)" [activeTab]="activeTab" [isLoading]="isLoading"></vw-tab>

  <!-- Le router-outlet vit HORS de vw-tab : il doit toujours être présent dans le DOM, sinon au
       retour sur l'onglet la route déjà active n'est pas re-rendue (outlet manquant). -->
  <div class="tab-content mb-28 mt-6">
    <router-outlet></router-outlet>
  </div>

  <!-- Toast « Que souhaitez-vous faire ? » (maquette 02) -->
  <vw-garden-actions-toast [isOpen]="showActionsToast" (close)="showActionsToast = false"></vw-garden-actions-toast>
</div>